export const TRACK_MUTE_GRACE_MS = 5000;

function recovery(kind, title, message, action, actionLabel) {
  return {
    source: "audio_health",
    kind,
    title,
    message,
    action,
    actionLabel,
    code: null,
  };
}

function contextIssue(kind, label, state, canResume) {
  if (!["suspended", "interrupted", "closed"].includes(state)) return null;
  if (state === "closed" || !canResume) {
    return recovery(
      kind,
      `${label} foi encerrado`,
      "Retome a voz para recriar o áudio ou continue por texto nesta conversa.",
      "restart_session",
      "Retomar voz",
    );
  }
  return recovery(
    kind,
    `${label} está pausado`,
    "O navegador pausou o áudio. Use Ativar áudio para continuar nesta conversa.",
    "resume_contexts",
    "Ativar áudio",
  );
}

export function getVoiceAudioIssue({
  micContextState,
  playContextState,
  trackReadyState,
  trackMuted = false,
  muteConfirmed = false,
  online,
  canResumeMic = false,
  canResumePlayback = false,
} = {}) {
  if (trackReadyState === "ended") {
    return recovery(
      "track_ended",
      "O microfone foi desconectado",
      "Reconecte ou selecione um microfone para retomar, ou continue por texto.",
      "restart_session",
      "Reconectar microfone",
    );
  }
  if (online === false) {
    return recovery(
      "offline",
      "A conexão ficou indisponível",
      "Quando a conexão voltar, tente retomar a voz ou continue por texto.",
      "restart_session",
      "Tentar novamente",
    );
  }
  const micIssue = contextIssue("mic_context", "A captura do microfone", micContextState, canResumeMic);
  if (micIssue) return micIssue;
  const playIssue = contextIssue("play_context", "A reprodução de áudio", playContextState, canResumePlayback);
  if (playIssue) return playIssue;
  if (trackMuted && muteConfirmed) {
    return recovery(
      "track_muted",
      "O microfone continua pausado",
      "Verifique o microfone e retome a voz quando estiver pronto, ou continue por texto.",
      "restart_session",
      "Retomar microfone",
    );
  }
  return null;
}
